import { render, staticRenderFns } from "./GroupUsersListModal.vue?vue&type=template&id=97c97594&"
import script from "./GroupUsersListModal.vue?vue&type=script&lang=js&"
export * from "./GroupUsersListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports